import type { ApiClient } from "@/modules/api/apiClient.ts";
import { getResponseData } from "@/modules/api/apiClient.ts";
import { atomFamilyMulti } from "@/utils/jotai/atomFamilyMulti.ts";
import { atomFromStandardQueryOptions } from "@/utils/query/queryAtom.ts";
import { queryOptions, type QueryKey } from "@tanstack/react-query";
import type { MetalCommitmentOffer } from "@warrenio/api-spec/spec.oats.gen";

type Response = MetalCommitmentOffer[];

function getQueryKey(params?: Params): QueryKey {
    return params == null ? ["metal/commitment_offer"] : ["metal/commitment_offer", params.location, params.uuid];
}

interface Params {
    location: string;
    uuid?: string;
}

function getQuery(client: ApiClient, params: Params) {
    return queryOptions({
        queryKey: getQueryKey(params),
        queryFn: async ({ signal }): Promise<Response> => {
            const { location, uuid } = params;
            if (uuid == null) {
                return getResponseData(
                    await client.GET("/{location}/metal/commitment_offers", {
                        signal,
                        params: { path: { location } },
                    }),
                );
            }

            return getResponseData(
                await client.GET("/{location}/metal/commitment_offers/{uuid}", {
                    signal,
                    params: { path: { location, uuid } },
                }),
            );
        },
    });
}

const commitmentOfferLocationQueryAtomFamily = atomFamilyMulti((location: string, uuid: string | null) =>
    atomFromStandardQueryOptions(getQuery, { location, uuid: uuid ?? undefined }),
);

export function commitmentOfferLocationQueryAtom(location: string, uuid?: string) {
    return commitmentOfferLocationQueryAtomFamily(location, uuid ?? null);
}
